import { AboutPage } from "./components/AboutPage";
import { AccountPage } from "./components/AccountPage";
import { AppCatalog } from "./components/AppCatalog";
import { AuthPage } from "./components/AuthPage";
import { BillingResultPage } from "./components/BillingResultPage";
import { CookiesPage } from "./components/CookiesPage";
import { CTA } from "./components/CTA";
import { ContactPage } from "./components/ContactPage";
import { DownloadPage } from "./components/DownloadPage";
import { Footer } from "./components/Footer";
import { Hero } from "./components/Hero";
import { LicensePage } from "./components/LicensePage";
import { Nav } from "./components/Nav";
import { NotFoundPage } from "./components/NotFoundPage";
import { Pricing } from "./components/Pricing";
import { PrivacyPage } from "./components/PrivacyPage";
import { ResetPasswordPage } from "./components/ResetPasswordPage";
import { TermsPage } from "./components/TermsPage";
import { VerifyEmailPage } from "./components/VerifyEmailPage";

export function App() {
  const normalizedPath = window.location.pathname.replace(/\/+$/, "") || "/";
  const isHomePage = normalizedPath === "/";
  const isAboutPage = normalizedPath === "/about";
  const isAccountPage = normalizedPath === "/account";
  const isDownloadPage = normalizedPath === "/download";
  const isSignInPage = normalizedPath === "/sign-in";
  const isContactPage = normalizedPath === "/contact";
  const isCookiesPage = normalizedPath === "/cookies";
  const isLicensePage = normalizedPath === "/license";
  const isTermsPage = normalizedPath === "/terms";
  const isPrivacyPage = normalizedPath === "/privacy";
  const isVerifyEmailPage = normalizedPath === "/verify-email";
  const isResetPasswordPage = normalizedPath === "/reset-password";
  const isBillingSuccessPage = normalizedPath === "/billing/success";
  const isBillingCancelledPage = normalizedPath === "/billing/cancelled";

  return (
    <div className="min-h-screen bg-bg text-text selection:bg-primary selection:text-white">
      <Nav />
      {isHomePage ? (
        <main>
          <Hero />
          <AppCatalog />
          <Pricing />
          <CTA />
        </main>
      ) : isAboutPage ? (
        <AboutPage />
      ) : isAccountPage ? (
        <AccountPage />
      ) : isContactPage ? (
        <ContactPage />
      ) : isCookiesPage ? (
        <CookiesPage />
      ) : isLicensePage ? (
        <LicensePage />
      ) : isPrivacyPage ? (
        <PrivacyPage />
      ) : isTermsPage ? (
        <TermsPage />
      ) : isDownloadPage ? (
        <DownloadPage />
      ) : isSignInPage ? (
        <AuthPage />
      ) : isVerifyEmailPage ? (
        <VerifyEmailPage />
      ) : isResetPasswordPage ? (
        <ResetPasswordPage />
      ) : isBillingSuccessPage ? (
        <BillingResultPage result="success" />
      ) : isBillingCancelledPage ? (
        <BillingResultPage result="cancelled" />
      ) : (
        <NotFoundPage />
      )}
      <Footer />
    </div>
  );
}
